import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=2c790e5b&"
import script from "./setup.vue?vue&type=script&lang=ts&"
export * from "./setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports